export const getIdiomas = (state) => state.idiomas.lista
export const getIsCarregandoListaIdiomas = (state) => state.idiomas.isCarregandoLista
